import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/mangas';
import MangaCard from '@/components/feature/MangaCard';

export default function LatestUpdates() {
  const sorted = [...mangas].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );
  const latest = sorted.slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              最近更新
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              追更党必看，最新话火速上线
            </p>
          </div>
          <Link to="/category/guoman" className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer">
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {latest.map((manga) => (
            <MangaCard key={`latest-${manga.id}`} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}